import React from "react";
import {
    CardContent,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemText, ListItemSecondaryAction, Chip,
} from "@mui/material";
import {DetailView} from "../../../../../Components";
import {useDispatch} from "react-redux";
import {styled} from "@mui/material/styles";
import {setSelectedRole} from "../../Redux/Action";

const StyledListItem = styled(ListItemText)(({ theme }) => ({
    '&:hover': {
        cursor: 'pointer',
    }
}));

export const Sidebar = ({items}) => {

    const dispatch = useDispatch();
    //split items with type - SYSTEM & BUSINESS.
    const [systemItems, businessItems] = items.reduce((acc, item) => {
        if (item.type === 'SYSTEM') {
            acc[0].push(item);
        } else {
            acc[1].push(item);
        }
        return acc;
    }, [[], []]);

    const handleRoleClick = (item) => {
        dispatch(setSelectedRole(item.id))
    };

    return (
        <DetailView>
            <CardContent>
                <Grid container spacing={0}>
                    <Grid className={"upper-section"} item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Typography variant={"h6"}>System Roles</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <List className={"item-details"}>
                                    { systemItems.map((item, index) => (
                                        <ListItem key={index}>
                                            <StyledListItem onClick={() => handleRoleClick(item)} primary={item.role_name} secondary={item?.description} />
                                            <ListItemSecondaryAction>
                                                <Chip size={"small"} color={"info"} label={item?.users_count} variant={"outlined"}/>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant={"h6"}>Business Roles</Typography>
                                <List className={"item-details"}>
                                    { businessItems.map((item, index) => (
                                        <ListItem key={index}>
                                            <StyledListItem onClick={() => handleRoleClick(item)} primary={item.role_name} secondary={item?.description} />
                                            <ListItemSecondaryAction>
                                                <Chip size={"small"} color={"info"} label={item?.users_count} variant={"outlined"}/>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </DetailView>
    );
};
